.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.quality {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
}

.qualityDetail {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--tuna-spacing-2);
}

.control {
  min-width: 6rem;
}
